<section class="carritoFin">

  <div class="spinner-overlay" *ngIf="cargando">
    <div class="spinner"></div>
  </div>

  
  <div class="txtNombre">
    <h2 class="titulo-evento3">RECLAMA TU TICKET</h2>
    <hr class="linea-naranja4" />
    <br>
    <div class="seccion">
      <div class="lineH lato text-1">
        <img class="logosEvents" src="../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 41.png" alt="">
        <div class="detalle1">
          <p>Cortesía gratuita válida para <span class="txPt2">1 TICKET</span></p>
        </div>
      </div>

      <div class="contenedor-principal">
        <div class="contenido-izquierda">
          <div class="montserrat tituloEvent">
            {{evento?.nombre}}
          </div>
          <div class="lato obsEvent">
            Recuerda que a tu correo recibirás un código QR que representa tu entrada
          </div>
          <div class="lato obsEvent2">
            <p>Cortesía para la localidad <span class="txPt2">{{localidad?.nombre}}</span></p>
          </div>
          <button class="btn btn-dark btn-lg mt-4" (click)="reclamar()" [disabled]="codigoCortesia?.utilizado">
            {{ codigoCortesia?.utilizado ? 'RECLAMADO' : 'RECLAMAR' }}
          </button>
        </div>
        
        <div class="ImgEvento">
          <img class="eventImg" src="{{darURL()}}" alt="">
        </div>
      </div>
    </div>
  </div>
</section>